const PagedList = require('../entities/paged-list');
/**
 * Recursively loads all remaining pages of data
 *
 * Usage:
 *
 *    client.list(...)
 *      .then(loadRest(client))
 *      .then(res => {
 *        // res == array of all results
 *      })
 */


const loadRest = (client
/*: ApiClient*/
) =>
/*: ((pagedList: PagedList<*>) => Promise<PagedList<*>>)*/
{
  function loader(response
  /*: PagedList<*>*/
  , accumulator
  /*: Array<*>*/
  = [])
  /*: Promise<PagedList<*>>*/
  {
    if (!response) return Promise.resolve(new PagedList(accumulator));
    const innerAccumulator = accumulator.concat(response.items);
    if (!response.page.next) return Promise.resolve(new PagedList(innerAccumulator));
    return client.get(response.page.next).then(innerResponse => loader(innerResponse, innerAccumulator));
  }

  return loader;
};

module.exports = loadRest;